import Controller from '@ember/controller';
import { computed, get } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  fundsService: service(),
  router: service(),
  store: service(),

  fundSetting: alias('model.mailchimpSetting.fundSettings.firstObject'),

  listName: computed('fundSetting.id', function () {
    let mcSetting = get(this, 'model.mailchimpSetting');
    let listId = get(this, 'fundSetting.mailchimpListId');
    if (listId) {
      return get(mcSetting, 'lists').find((x) => {
        return get(x, 'id') === listId;
      }).name;
    } else {
      return '';
    }
  }),

  delete: task(function* () {
    yield this.fundsService.confirmValidFundToken();
    let model = get(this, 'model.mailchimpSetting');
    yield model.destroyRecord();
    this.send('refreshMailchimpRoute');
    this.router.transitionTo('funds.fund.more.mailchimp');
  }).drop(),
});
